module.exports = __webpack_public_path__ + "static/img/apply_kunming.946580de.png";